import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const faceSettingRouter: RouteConfig = {
  path: "/faceSettings",
  component: Layout,
  meta: {
    title: "人脸识别",
    icon: "setting",
    permission: "Pages.Settings"
  },
  children: [
    {
      path: "facePermission",
      name:'facePermission',
      component: () =>
        import(
          /* webpackChunkName: "score-settings" */ "@/views/face-settings/index.vue"
        ),
      meta: {
        title: "人脸识别设置",
        icon: "setting",
        permission: "Pages.Settings"
      }
    },
  ]
};

export default faceSettingRouter;
